import { SubService, UtilityType } from '../types/utility.types';
import axios from './axiosConfig';

interface ApiResponse<T> {
  data: T;
}

export const getAllSubServices = async (): Promise<SubService[]> => {
  try {
    const response = await axios.get<ApiResponse<SubService[]>>('/utility-sub-services');
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching all sub-services:', error);
    return [];
  }
};

export const fetchSubServices = async (utilityType: UtilityType): Promise<SubService[]> => {
  try {
    // Normalize the service type to match the expected format on the server
    // Convert to uppercase to match the enum values in the backend
    const normalizedType = utilityType.toUpperCase();
    
    // Map common variations to standard types
    let standardizedType = normalizedType;
    if (normalizedType === 'ELECTRIC') standardizedType = 'Electricity';
    if (normalizedType === 'TELECOM') standardizedType = 'Telecoms';
    
    console.log(`Fetching sub-services for type: ${utilityType} (normalized to: ${standardizedType})`);
    const response = await axios.get<ApiResponse<SubService[]>>(`/utility-sub-services/by-type/${standardizedType}`);
    console.log('Sub-services API response:', response.data);
    return response.data.data || [];
  } catch (error) {
    console.error('Error fetching sub-services:', error);
    return []; // Return empty array instead of throwing to prevent form errors
  }
};

export const createSubService = async (subServiceData: Omit<SubService, '_id'>): Promise<SubService> => {
  try {
    const response = await axios.post<ApiResponse<SubService>>('/utility-sub-services', subServiceData);
    return response.data.data;
  } catch (error) {
    
    throw error;
  }
};

export const updateSubService = async (id: string, subServiceData: Partial<SubService>): Promise<SubService> => {
  try {
    const response = await axios.put<ApiResponse<SubService>>(`/utility-sub-services/${id}`, subServiceData);
    return response.data.data;
  } catch (error) {
    
    throw error;
  }
};

export const deleteSubService = async (id: string): Promise<void> => {
  try {
    await axios.delete(`/utility-sub-services/${id}`);
  } catch (error) {
    console.error('Error deleting sub-service:', error);
    throw error;
  }
};
